import { TestimonialsComponent } from './testimonials/testimonials.component';
import { LegalComponent } from './legal/legal.component';
import { ServicesCarouselComponent } from './services/services-home-screen/services-carousel.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ServicesComponent } from './services/services.component';
import { AppointmentsComponent } from './appointments/appointments.component';
import { FooterComponent } from './footer/footer.component';
import { AboutComponent } from './about/about.component';
import { NavComponent } from './navigation/nav.component';
import { AppMainComponent } from './app-main.component';
import { HomeComponent } from './home/home.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutsRoutingModule } from './layouts-routing.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SwiperModule, SWIPER_CONFIG, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module'
import { CountToModule } from 'angular-count-to';
import { AngularTiltModule } from 'angular-tilt';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng5SliderModule } from 'ng5-slider';
import { MeetTheTeamComponent } from './meet-the-team/meet-the-team.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ServiceReadMoreComponent } from './services/services-home-screen/service-read-more/service-read-more.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {};

@NgModule({
  declarations: [
    AppMainComponent,
    NavComponent,
    HomeComponent,
    MeetTheTeamComponent,
    AboutComponent,
    AppointmentsComponent,
    LegalComponent,
    ServicesComponent,
    ServicesCarouselComponent,
    TestimonialsComponent,
    ContactUsComponent,
    FooterComponent,
    ServiceReadMoreComponent
  ],

  imports: [
    CommonModule,
    LayoutsRoutingModule,
    SwiperModule,
    CarouselModule,
    NgbModule,
    SharedModule,
    CountToModule,
    AngularTiltModule,
    FormsModule,
    ReactiveFormsModule,
    Ng5SliderModule,
    PopoverModule.forRoot()
  ],

  exports: [],

  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ]
})

export class LayoutsModule { }
